import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInformationService, ArkUnitOfWork, AuthService, DocumentService, UtilityService } from 'app/core/core.module';
import { Campaign, CampaignAction, CampaignOptOut, Person } from 'app/core/model/entity-model';
import { DxDataGridComponent, DxDataGridModule, DxDateBoxModule, DxFormModule, DxSelectBoxModule } from 'devextreme-angular';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/internal/Subject';

@Component({
    standalone: true,
    imports: [DxDataGridModule, DxDateBoxModule, DxFormModule, DxSelectBoxModule],
    selector: 'app-campaign-dialog',
    template: `
        <div class="modal-header">
            <h5 class="modal-title">Project Line Task</h5>
        </div>
        <div class="modal-body">
            <dx-form [formData]="campaignAction">
                <dxi-item dataField="date" [label]="{ text: 'Date' }" [editorType]="'dxDateBox'" [editorOptions]="{ width: '150px' }"></dxi-item>
                <dxi-item dataField="name" [label]="{ text: 'Name' }"></dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" (click)="save()">Save</button>
            <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
        </div>
    `,
    styles: ``,
})
export class CampaignDialogComponent implements OnInit {
    campaigns: Campaign[] = [];
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('optOutGrid') optOutGrid: DxDataGridComponent;
    router = inject(Router);
    route = inject(ActivatedRoute);
    modalRef = inject(BsModalRef);

    result: Subject<any> = new Subject<any>();
    campaignAction: CampaignAction;
    campaignId: number;
    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        private modalService: BsModalService,
        public appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        if (!this.campaignAction) {
            this.campaignAction = this.uow.campaignActions.createEntity({
                campaignId: this.campaignId,
                date: new Date(),
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            });
        }
    }

    async save() {
        await this.uow.commit();
        this.result.next({ success: true, value: this.campaignAction });
        this.modalRef.hide();
    }

    cancel() {
        this.uow.rollback();
        this.result.next({ success: false });
        this.modalRef.hide();
    }
}
